//hooks
import { useState, useRef, useEffect } from "react";

//styles
import "../../styles/cards.css";

//components
import { Box, Typography, Link, useTheme } from "@mui/material";

//actions
import { removeHtmlTags } from "../../actions";

//utils
import { addItemsToLocalStorage } from "../../utils/functions";
import { useMode } from "../../context/ModeProvider";
import { useDispatch, useSelector } from "react-redux";
import NewsLikeDislike from "../LikeAndDislike/NewsLikeDislikes";
import ReactionsOptions from "../LikeAndDislike/ReactionsOptions";
//icons
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";

const ImageInfoCard = ({
    id = null,
    title = "",
    content = "",
    logo = "",
    source = "",
    image = "",
    link = "",
    tags = null,
    countLikes = 0,
    countDislikes = 0,
    options = {},
}) => {
    const news = useSelector((state) => state.news);

    const dispatch = useDispatch();

    const theme = useTheme();
    const { modeState } = useMode();
    const contentRef = useRef(null);

    const [heightVar, setHeightVar] = useState(0);
    const [imageLoaded, setImageLoaded] = useState(false);
    const {
        width = "100%",
        height = "266px",
        colSpan = "",
        titleSize = "18px",
        contentSize = "1rem",
        sourceSize = { xl: "16px", lg: "16px", xs: "14px", sm: "14px" },
        likeCtGap = "10px",
        imgObjectFit = options.imgObjectFit || "cover",
    } = options;

    const randomGradient = `gradient-${Math.floor(Math.random() * 10) + 1}`;
    const cardStyle = {
        "--content-height": heightVar,
    };
    const isImageUrlValid = image.startsWith("https://") || image.startsWith("http://");

    useEffect(() => {
        if (contentRef.current && content) {
            const height = contentRef.current.scrollHeight;
            setHeightVar(`${height}px`);
            //document.documentElement.style.setProperty('--content-height', `${height}px`);
        }
    }, [contentRef.current]);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };
    const handleImageError = () => {
        setImageLoaded(false);
    };

    const handleAddTagsOnClick = (e) => {
        addItemsToLocalStorage("newsTags", tags);
    };

    return (
        <Box
            onClick={tags && handleAddTagsOnClick}
            className="cardimage-mainct"
            style={cardStyle}
            sx={{
                display: "flex",
                overflow: "hidden",
                borderRadius: "5px",
                flexDirection: "column",
                color: "white",
                gridColumn: colSpan,
                cursor: "pointer",
                position: "relative",
                width: width,
                height: height,
            }}
        >
            <Link
                href={link}
                target="_blank"
                style={{ width: "100%", height: "100%", position: "absolute", zIndex: "40" }}
            />
            <Box className="cardimage-top-container">
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        paddingTop: "10px",
                        alignItems: "flex-start",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "4px",
                            paddingLeft: "10px",
                        }}
                    >
                        {logo && (
                            <Box>
                                <img src={logo} style={{ maxHeight: "16px" }} />
                            </Box>
                        )}

                        <Typography
                            component="h6"
                            sx={{
                                fontSize: sourceSize,
                                color: theme.noticeCard.text,
                                background:
                                    modeState.mode === "dark"
                                        ? "linear-gradient(to right, #FFEOB2, #FFF3EO)"
                                        : "linear-gradient(to right, #FFCDD2, #FFEBEE)",

                                WebkitBackgroundClip: "text",
                                textShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
                            }}
                        >
                            {source}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            zIndex: "50",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-end",
                            gap: "5px",
                        }}
                    >
                        <Link href={`/comunidad/noticia/${id}`}>
                            <CommentRoundedIcon fontSize="small" />
                        </Link>
                        {/*<NewsLikeDislike
                            newsId={id}
                            countLikes={countLikes}
                            countDislikes={countDislikes}
                        />*/}
                        <ReactionsOptions
                            postId={id}
                            nameEntityPost={"news-adders"}
                            url={"/news-adders"}
                            countLikes={countLikes}
                            countDislikes={countDislikes}
                            options={{
                                iconUnselectedColor: theme.noticeCard.text,
                            }}
                        />
                    </Box>
                </Box>
            </Box>

            <Box sx={{ position: "relative", height: "100%" }} className="cardimage-info">
                <Box
                    sx={{ width: "100%", paddingRight: "10px", paddingLeft: "10px", marginTop: "8px" }}
                    className={`cardimage-title ${content && "cardimage-hover-title"}`}
                >
                    <Typography
                        className="cardimage-title-clamp"
                        component="h2"
                        sx={{
                            fontSize: titleSize,
                            fontWeight: "600",
                            color: theme.noticeCard.text,
                            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
                            background:
                                modeState.mode === "dark"
                                    ? "linear-gradient(to right, #FFEOB2, #FFF3EO)"
                                    : "linear-gradient(to right, #FFCDD2, #FFEBEE)",

                            WebkitBackgroundClip: "text",
                            //textShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
                <Box
                    className={`cardimage-content ${content && "cardimage-hover-content"}`}
                    ref={contentRef}
                >
                    <Typography
                        className="cardimage-content-p"
                        component="p"
                        sx={{
                            paddingRight: "10px",
                            paddingLeft: "10px",
                            fontSize: contentSize,
                            color: theme.noticeCard.text,
                            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
                            background:
                                modeState.mode === "dark"
                                    ? "linear-gradient(to right, #FFEOB2, #FFF3EO)"
                                    : "linear-gradient(to right, #FFCDD2, #FFEBEE)",

                            WebkitBackgroundClip: "text",
                        }}
                    >
                        {removeHtmlTags(content)}
                    </Typography>
                </Box>
            </Box>

            <Box
                className="cardimage-imagebg"
                bgcolor={"background.paper"}
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                }}
            >
                {isImageUrlValid ? (
                    <>
                        {!imageLoaded && (
                            <Box
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                className={randomGradient}
                            ></Box>
                        )}
                        <img
                            style={{
                                position: "absolute",
                                top: "0px",
                                bottom: "0px",
                                width: "100%",
                                height: "100%",
                                objectFit: imgObjectFit,
                                objectPosition: "center",
                            }}
                            src={image}
                            onLoad={handleImageLoad}
                            onError={handleImageError}
                        />
                    </>
                ) : (
                    <Box
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        className={randomGradient}
                    ></Box>
                )}
            </Box>
        </Box>
    );
};

export default ImageInfoCard;
